{
  "No orders found for this selection": "No orders found for this selection",
  "Building CSV...": "Creating CSV",
  "Created": "Created",
  "Name": "Name",
  "E-mail": "E-mail",
  "e.g. jane.doe@company.com": "e.g. jane.doe@company.com",
  "Product": "Product",
  "State": "Status",
  "Pending": "Pending",
  "Approved": "Approved",
  "All Products": "All products",
  "Order History": "Order history",
  "No username found": "No username found",
  "No email found": "No email found",
  "Something went wrong with this order. Contact system admin about it.": "Something went wrong with this order. Contact support.",
  "Are you sure that you want to approve this user?": "Are you sure that you want to approve this user?",
  "Are you sure that you want to reject this user?": "Are you sure that you want to reject this user?",
  "Approve": "Approve",
  "Id": "ID",
  "User": "User",
  "All States": "All status",
  "Cancel": "Cancel",
  "Review": "Review",
  "Updated at": "Updated at",
  "By user": "By user",
  "To state": "To status",
  "found-total": "Found {{count}} order",
  "found-total_plural": "Found {{count}} orders",
  "No user with that e-mail found": "No user with that e-mail found",
  "Filter by Product": "Filter by product",
  "Filter by State": "Filter by status",
  "Filter by E-mail address": "Filter by e-mail address",
  "Expand": "Expand",
  "Re-run registration?": "Re-run registration?",
  "Licenses": "Licenses"
}
